// extracted by mini-css-extract-plugin
export var card = "_sd-0";